import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Textarea
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

import { FindingDecision, MAX_DECISION_COMMENT } from '../../../../models/Entities/Contracts/ContractReview';

// Diálogo de decisión (US4): individual o en bloque, con comentario opcional de hasta 2000 caracteres (límite de Contracts).

export interface ContractReviewDecisionDialogProps {
  open: boolean;
  decision: FindingDecision;
  /** En bloque: cuántos hallazgos; sin valor, decisión individual. */
  count?: number;
  initialComment?: string | null;
  busy?: boolean;
  onConfirm: (comment: string | null) => void;
  onCancel: () => void;
}

const titleKey = (decision: FindingDecision, bulk: boolean): string => {
  const suffix = decision === 'Accepted' ? 'Accept' : decision === 'Rejected' ? 'Reject' : 'Reset';
  return bulk ? `contractReview.bulk.title${suffix}` : `contractReview.decisionActions.title${suffix}`;
};

export const ContractReviewDecisionDialog: React.FC<ContractReviewDecisionDialogProps> = props => {
  const { t } = useTranslation();
  const [comment, setComment] = useState(props.initialComment ?? '');

  useEffect(() => {
    if (props.open) setComment(props.initialComment ?? '');
  }, [props.open, props.initialComment]);

  return (
    <Dialog open={props.open} onOpenChange={(_, data) => !data.open && props.onCancel()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t(titleKey(props.decision, props.count !== undefined), { count: props.count })}</DialogTitle>
          <DialogContent>
            <Field label={t('contractReview.decisionActions.comment')} hint={t('contractReview.decisionActions.commentHint', { max: MAX_DECISION_COMMENT })}>
              <Textarea value={comment} maxLength={MAX_DECISION_COMMENT} onChange={(_, data) => setComment(data.value)} resize="vertical" />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={props.onCancel}>
              {t('contractReview.decisionActions.cancel')}
            </Button>
            <Button appearance="primary" disabled={props.busy} onClick={() => props.onConfirm(comment.trim() ? comment.trim() : null)}>
              {t('contractReview.decisionActions.confirm')}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ContractReviewDecisionDialog;
